import httpClient from 'shared/lib/httpClient';
import { superAdminEndpoints } from 'features/claim/shared/api/super-admin-endpoints';
import { parseClaimTypeList } from '../schemas/MasterDataSchema';

export const getClaimTypeList = async (params, signal, companyId = null) => {
  const endpoint = companyId
    ? superAdminEndpoints.claimTypes(companyId)
    : '/claim-types';
  const response = await httpClient.get(endpoint, { params, signal });
  return parseClaimTypeList(response?.data);
};
